import { Link } from "gatsby";
import * as React from "react";
import Accordion from "react-bootstrap/Accordion";
import {
  activityContainer,
  container,
  myStaysTitle,
  programDetails,
  styledAccordion,
  styledCTA,
  styledLink,
  toggleIcon,
  toggleTitle,
} from "./ProfileMain.module.scss";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};

export const StyledAccordion: React.FC<any> = (props) => {
  return (
    <Accordion className={`${styledAccordion} mb-5 mt-5`} defaultActiveKey="0">
      {props.children}
    </Accordion>
  );
};

export const StyledCTA: React.FC<any> = (props) => {
  return <div className={styledCTA}>{props.children}</div>;
};

export const ActivityContainer: React.FC<any> = (props) => {
  return <div className={activityContainer}>{props.children}</div>;
};

export const StyledLink: React.FC<any> = (props) => {
  return (
    <Link id={props.id} className={styledLink} {...props}>
      {props.children}
    </Link>
  );
};

export const ToggleTitle: React.FC<any> = (props) => {
  return (
    <span id={props.id} className={toggleTitle} {...props}>
      {props.children}
    </span>
  );
};

export const ToggleIcon: React.FC<any> = (props) => {
  return (
    <span className={toggleIcon} {...props}>
      {props.children}
    </span>
  );
};

export const ProgramDetails: React.FC = () => {
  return (
    <div className={programDetails}>
      <h5
        id={"program-details"}
        className={`pt-2 px-3 mb-0 styledProfileTitle`}
      >
        Program Details
      </h5>
      <ul>
        <li>
          <StyledLink id="member-benefits" to={`/travel-pass`}>
            Member Benefits
          </StyledLink>
        </li>
        <li>
          <StyledLink
            id="exclusive-offers"
            to={`/travel-pass/exclusive-offers`}
          >
            Exclusive Offers
          </StyledLink>
        </li>
        <li>
          <StyledLink id="frequently-asked-questions" to={`/support`}>
            Frequently Asked Questions
          </StyledLink>
        </li>
        <li>
          <StyledLink id="contact-customer-care" to={`/contact`}>
            Contact Customer Care
          </StyledLink>
        </li>
        <li>
          <StyledLink
            id="terms-and-conditions"
            to={`/travel-pass/terms-conditions`}
          >
            Terms and Conditions
          </StyledLink>
        </li>
      </ul>
    </div>
  );
};
export const MyStaysTitle: React.FC = () => {
  return (
    <h5
      id="my-stays-title"
      className={`pt-2 mb-3 px-3 styledProfileTitle ${myStaysTitle}`}
    >
      My Stays
    </h5>
  );
};
